import '../styles/Tailwind.css'
import React from 'react'
import { Compare } from '../components/ui/compare'

const TestPage: React.FC = () => {
  return (
    <div className="tw-w-3/4 tw-h-[60vh] tw-px-1 tw-md:px-8 tw-flex tw-items-center tw-justify-center tw-perspective-800 tw-transform-style-preserve">
      <div
        style={{
          transform: 'rotateX(15deg) translateZ(80px)',
        }}
        className="tw-p-1 tw-md:p-4 tw-border tw-rounded-3xl tw-dark:bg-neutral-900 tw-bg-neutral-100 tw-border-neutral-200 tw-dark:border-neutral-800 tw-mx-auto tw-w-3/4 tw-h-1/2 tw-md:h-3/4"
      >
        <Compare
          firstImage="https://assets.aceternity.com/notes-dark.png"
          secondImage="https://assets.aceternity.com/linear-dark.png"
          firstImageClassName="object-cover object-left-top w-full"
          secondImageClassname="object-cover object-left-top w-full"
          className="tw-w-full tw-h-full tw-rounded-[22px] tw-md:rounded-lg"
          slideMode="hover"
          autoplay={true}
        />
      </div>
    </div>
  )
}

export default TestPage
